import { HomeBox } from "./Home.styles";
import {
  NavBar,
  HeroSection,
  VendorGetStarted,
  BookADemo,
  Features,
  Contact,
  Footer,
} from "../components";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { scroller } from "react-scroll";
import { Helmet } from "react-helmet";
import { TSelectableMode } from "../../../types";


export default function Home() {
  const { state, pathname } = useLocation();
  const [selectedMode, setSelectedMode] =
    React.useState<TSelectableMode>("Convener");
  const params = useParams();

  console.log(params);

  React.useEffect(() => {
    if (params && params.feature) {
      handleGoToFeatures();
    }
  }, [params]);

  React.useEffect(() => {
    if (state && state.mode) {
      setSelectedMode(state.mode);
    }
  }, [pathname]);

  const handleGoToFeatures = () => {
    scroller.scrollTo("featureSection", {
      duration: 500,
      delay: 0,
      smooth: "easeInOutQuart",
      offset: -70, // Adjust as needed
    });
  };

  const handleMode = (mode: TSelectableMode) => {
    setSelectedMode(mode);
  };

  return (
    <>
      <Helmet>
        <title>Frondesq | Home</title>
        <meta
          name="description"
          content="Frondesq - Create, manage and share your events"
        />
        <meta property="og:title" content="Frondesq | Home" />
        <meta
          property="og:description"
          content="Frondesq - Create, manage and share your events"
        />
        {/* <meta property="og:image" content={data?.bannerUrl} /> */}
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />

        <meta property="twitter:title" content="Frondesq | Home" />
        <meta
          property="twitter:description"
          content="Frondesq - Create, manage and share your events"
        />
        {/* <meta property="twitter:image" content={data?.bannerUrl} /> */}
      </Helmet>

      <NavBar handleModeChange={handleMode} selectedMode={selectedMode} />
      <HeroSection selectedMode={selectedMode} />
      {selectedMode === "Vendor" && <VendorGetStarted />}
      <BookADemo />
      <Features />
      <Contact />
      <Footer />
    </>
  );
}
